import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import closeeye from "../assets/images/closeEye.svg";
import infoIcon from "../assets/images/infobtnblue.svg";
import openeye from "../assets/images/viewaction.svg";
import googleIcon from "../assets/images/google.svg";
import microsoftLogo from "../assets/images/microsoft.svg";
import dropboxLogo from "../assets/images/dropbox.svg";
import shopifyLogo from "../assets/images/shopify.svg";
import zoomLogo from "../assets/images/zoom.svg";
import calendlyLogo from "../assets/images/calendly.svg";
import slackLogo from "../assets/images/slack.svg";
import notionLogo from "../assets/images/notion.svg";
import bitlyLogo from "../assets/images/bitly.svg";
import discordLogo from "../assets/images/discord.svg";
import yahooLogo from "../assets/images/yahoo.svg";

import Loader, { LoaderType } from "../component/common-component/Loader";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";
import { commonservices } from "../services/CommonServices";
import VaultTypeIcon from "../component/common-component/VaultTypeIcon";
import {
    PasswordVaultDetail,
    PasswordVaultSave,
} from "../services/ReduxTookit/Slice/PasswordVaultRedux";
import { OAuthVaultGetRedirectUrl } from "../services/ReduxTookit/Slice/OAuthVaultRedux";
import { resolveOAuthProvider } from "./OAuthProviderConfig";
import "./PasswordVaultWizard.css";

// Google Scopes definition matching application standards
const GOOGLE_SCOPE_GROUPS = {
    "User Info": [
        { id: "userinfo.email", scope: "https://www.googleapis.com/auth/userinfo.email", label: "Email Address", description: "View your email address" },
    ],
    "Gmail": [
        { id: "gmail.readonly", scope: "https://www.googleapis.com/auth/gmail.readonly", label: "Read Only", description: "View your email messages and settings" },
        { id: "gmail.compose", scope: "https://www.googleapis.com/auth/gmail.compose", label: "Compose", description: "Create, read, update, and delete drafts. Send messages and drafts" },
        { id: "gmail.modify", scope: "https://www.googleapis.com/auth/gmail.modify", label: "Modify", description: "View and modify but not delete your email" },
        { id: "gmail.insert", scope: "https://www.googleapis.com/auth/gmail.insert", label: "Insert", description: "Insert mail into your mailbox" },
        { id: "gmail.labels", scope: "https://www.googleapis.com/auth/gmail.labels", label: "Labels", description: "Manage mailbox labels" },
        { id: "gmail.metadata", scope: "https://www.googleapis.com/auth/gmail.metadata", label: "Metadata", description: "View your email message metadata" },
        { id: "gmail.settings.basic", scope: "https://www.googleapis.com/auth/gmail.settings.basic", label: "Basic Settings", description: "Manage your basic mail settings" },
        { id: "gmail.settings.sharing", scope: "https://www.googleapis.com/auth/gmail.settings.sharing", label: "Sharing Settings", description: "Manage your sensitive mail settings" },
        { id: "mail.full", scope: "https://mail.google.com/", label: "Full Access", description: "Read, compose, send, and permanently delete all your email" },
    ],
    "Google Drive": [
        { id: "drive", scope: "https://www.googleapis.com/auth/drive", label: "Full Access", description: "See, edit, create, and delete all of your Google Drive files" },
        { id: "drive.readonly", scope: "https://www.googleapis.com/auth/drive.readonly", label: "Read Only", description: "See and download all your Google Drive files" },
        { id: "drive.file", scope: "https://www.googleapis.com/auth/drive.file", label: "File Access", description: "See, edit, create, and delete only files opened with this app" },
        { id: "drive.appdata", scope: "https://www.googleapis.com/auth/drive.appdata", label: "App Data", description: "View and manage application-specific data" },
        { id: "drive.metadata", scope: "https://www.googleapis.com/auth/drive.metadata", label: "Metadata", description: "View and manage metadata of files" },
        { id: "drive.metadata.readonly", scope: "https://www.googleapis.com/auth/drive.metadata.readonly", label: "Metadata Read Only", description: "View metadata for files" },
        { id: "drive.photos.readonly", scope: "https://www.googleapis.com/auth/drive.photos.readonly", label: "Photos Read Only", description: "View photos, videos, and albums" },
    ],
    "Google Docs": [
        { id: "documents", scope: "https://www.googleapis.com/auth/documents", label: "Full Access", description: "See, edit, create, and delete all Google Docs documents" },
        { id: "documents.readonly", scope: "https://www.googleapis.com/auth/documents.readonly", label: "Read Only", description: "View your Google Docs documents" },
    ],
    "Google Sheets": [
        { id: "spreadsheets", scope: "https://www.googleapis.com/auth/spreadsheets", label: "Full Access", description: "See, edit, create, and delete all Google Sheets spreadsheets" },
        { id: "spreadsheets.readonly", scope: "https://www.googleapis.com/auth/spreadsheets.readonly", label: "Read Only", description: "View your Google Sheets spreadsheets" },
    ],
    "Google Calendar": [
        { id: "calendar", scope: "https://www.googleapis.com/auth/calendar", label: "Full Access", description: "See, edit, share, and permanently delete all calendars" },
        { id: "calendar.readonly", scope: "https://www.googleapis.com/auth/calendar.readonly", label: "Read Only", description: "View your calendars" },
        { id: "calendar.events", scope: "https://www.googleapis.com/auth/calendar.events", label: "Events", description: "View and edit events on all your calendars" },
        { id: "calendar.events.readonly", scope: "https://www.googleapis.com/auth/calendar.events.readonly", label: "Events Read Only", description: "View events on all your calendars" },
        { id: "calendar.settings.readonly", scope: "https://www.googleapis.com/auth/calendar.settings.readonly", label: "Settings Read Only", description: "View your Calendar settings" },
    ],
    "Google Tasks": [
        { id: "tasks", scope: "https://www.googleapis.com/auth/tasks", label: "Full Access", description: "Create, edit, organize, and delete all your tasks" },
        { id: "tasks.readonly", scope: "https://www.googleapis.com/auth/tasks.readonly", label: "Read Only", description: "View your Google Tasks" },
    ],
    "Google Slides": [
        { id: "presentations", scope: "https://www.googleapis.com/auth/presentations", label: "Full Access", description: "See, edit, create, and delete all Google Slides presentations" },
        { id: "presentations.readonly", scope: "https://www.googleapis.com/auth/presentations.readonly", label: "Read Only", description: "View your Google Slides presentations" },
    ],
    "Contacts": [
        { id: "contacts", scope: "https://www.googleapis.com/auth/contacts", label: "Full Access", description: "See, edit, download, and permanently delete your contacts" },
        { id: "contacts.readonly", scope: "https://www.googleapis.com/auth/contacts.readonly", label: "Read Only", description: "View your contacts" },
        { id: "directory.readonly", scope: "https://www.googleapis.com/auth/directory.readonly", label: "Directory Read Only", description: "View your organization's GSuite directory" },
        { id: "user.addresses.read", scope: "https://www.googleapis.com/auth/user.addresses.read", label: "Addresses", description: "View your street addresses" },
        { id: "user.phonenumbers.read", scope: "https://www.googleapis.com/auth/user.phonenumbers.read", label: "Phone Numbers", description: "View your phone numbers" },
    ],
};

// Known prototype types metadata
const PROTOTYPE_TYPES = [
    { term: "Gmail", symbol: "✉️", description: "Email access credentials", isOAuth: false },
    { term: "PostgreSQL", symbol: "🐘", description: "PostgreSQL database credentials", isOAuth: false },
    { term: "SQL Server", symbol: "▣", description: "Database connection credentials", isOAuth: false },
    { term: "MySQL", symbol: "🐬", description: "Database connection credentials", isOAuth: false },
    { term: "Outlook", symbol: "📧", description: "Outlook email credentials", isOAuth: false },
    { term: "PMS Connect", symbol: "↗", description: "Hotel PMS integration credentials", isOAuth: false },
    { term: "Google Authenticator", icon: googleIcon, symbol: "🌐", description: "Access Google services using OAuth", isGoogle: true, isOAuth: true },
    { term: "Generic API", symbol: "⚙️", description: "Store API keys or tokens", isOAuth: false },
    { term: "Others", symbol: "◇", description: "Custom credentials", isOAuth: false },
];

const OAUTH_ICONS = {
    microsoft: microsoftLogo,
    dropbox: dropboxLogo,
    shopify: shopifyLogo,
    zoom: zoomLogo,
    calendly: calendlyLogo,
    slack: slackLogo,
    notion: notionLogo,
    bitly: bitlyLogo,
    discord: discordLogo,
    yahoo: yahooLogo,
};

// Default fields for non-OAuth standard types
const getDefaultFieldsForType = (typeName) => {
    if (typeName === "SQL Server") {
        return [
            { keyname: "username", display: "User Name", keytype: "Text Box", value: "" },
            { keyname: "password", display: "Password / Secret", keytype: "Password", value: "" },
            { keyname: "host", display: "Host / Server", keytype: "Text Box", value: "" },
            { keyname: "port", display: "Port", keytype: "Number", value: "1433" },
            { keyname: "database", display: "Database Name", keytype: "Text Box", value: "" },
            { keyname: "description", display: "Description (Optional)", keytype: "Text Area", value: "" },
        ];
    }
    if (typeName === "MySQL") {
        return [
            { keyname: "username", display: "User Name", keytype: "Text Box", value: "" },
            { keyname: "password", display: "Password / Secret", keytype: "Password", value: "" },
            { keyname: "host", display: "Host / Server", keytype: "Text Box", value: "" },
            { keyname: "port", display: "Port", keytype: "Number", value: "3306" },
            { keyname: "database", display: "Database Name", keytype: "Text Box", value: "" },
            { keyname: "description", display: "Description (Optional)", keytype: "Text Area", value: "" },
        ];
    }
    if (typeName === "PMS Connect") {
        return [
            { keyname: "username", display: "User Name", keytype: "Text Box", value: "" },
            { keyname: "password", display: "Password / Secret", keytype: "Password", value: "" },
            { keyname: "property", display: "Property Code", keytype: "Text Box", value: "" },
            { keyname: "endpoint", display: "API Endpoint", keytype: "Text Box", value: "" },
            { keyname: "description", display: "Description (Optional)", keytype: "Text Area", value: "" },
        ];
    }
    if (typeName === "Generic API") {
        return [
            { keyname: "apiKey", display: "API Key / Token", keytype: "Password", value: "" },
            { keyname: "endpoint", display: "API Endpoint", keytype: "Text Box", value: "" },
            { keyname: "description", display: "Description (Optional)", keytype: "Text Area", value: "" },
        ];
    }
    if (typeName === "Gmail" || typeName === "Others") {
        return [
            { keyname: "username", display: "User Name", keytype: "Text Box", value: "" },
            { keyname: "password", display: "Password / Secret", keytype: "Password", value: "" },
            { keyname: "description", display: "Description (Optional)", keytype: "Text Area", value: "" },
        ];
    }
    return [
        { keyname: "username", display: "User Name", keytype: "Text Box", value: "" },
        { keyname: "password", display: "Password / Secret", keytype: "Password", value: "" },
        { keyname: "description", display: "Description (Optional)", keytype: "Text Area", value: "" },
    ];
};

const PasswordVaultModal = (props) => {
    const dispatch = useDispatch();

    const [Loading, setLoading] = useState(false);
    const [authLoading, setAuthLoading] = useState(false);
    const [UpdateLoader, setUpdateLoader] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [currentStep, setCurrentStep] = useState(props?.type === "Update" ? 2 : 1);

    const getInitialType = () => {
        if (props?.type === "Update" && props?.selecteddata?.type) {
            return props.selecteddata.type;
        }
        if (props?.vaulttypelist && props.vaulttypelist.length > 0) {
            return props.vaulttypelist[0].term;
        }
        return PROTOTYPE_TYPES[0]?.term || "Gmail";
    };

    const initialType = getInitialType();

    // Form input state matching backend schema
    const [input, setInput] = useState({
        passwordvaultid: 0,
        type: initialType,
        detailsjson: getDefaultFieldsForType(initialType),
        displayname: "",
        username: "",
        password: "",
        errors: {
            type: "",
            displayname: "",
            ValidationRules: [
                {
                    FieldName: "type",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
                {
                    FieldName: "displayname",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
            ],
        },
    });

    // OAuth specific states
    const [selectedScopes, setSelectedScopes] = useState(["userinfo.email"]);
    const [expandedGroups, setExpandedGroups] = useState({ "User Info": true });
    const [shopDomain, setShopDomain] = useState("");
    const [shopDomainError, setShopDomainError] = useState("");

    // Helper to determine if a type is Google
    const isGoogle = (typeName) => {
        if (!typeName) return false;
        const lower = typeName.toLowerCase();
        return lower === "google authenticator" || lower === "google drive" || lower === "google sheets" || lower.includes("google");
    };

    // Helper to determine if a type is OAuth
    const isOAuthType = (typeName) => {
        const typeToCheck = typeName || input?.type;
        return isGoogle(typeToCheck) || !!resolveOAuthProvider(typeToCheck);
    };

    const oauthConfig = resolveOAuthProvider(input?.type);

    // Compute dynamic step labels matching prototype
    const stepLabels = isOAuthType(input?.type)
        ? ["Select Type", "Configure", "Permissions", "Review", "Authorize"]
        : ["Select Type", "Configure", "Review"];

    // Helper to get icon/symbol metadata for any vault type
    const getTypeMetadata = (term) => {
        const lower = term?.toLowerCase() || "";
        if (lower.includes("google")) {
            return { icon: googleIcon, symbol: "🌐", description: "Access Google services using OAuth", isOAuth: true };
        }
        if (lower.includes("postgresql") || lower.includes("postgres")) {
            return { symbol: "🐘", description: "PostgreSQL database credentials", isOAuth: false };
        }
        if (lower.includes("sql server")) {
            return { symbol: "▣", description: "Database connection credentials", isOAuth: false };
        }
        if (lower.includes("mysql")) {
            return { symbol: "🐬", description: "Database connection credentials", isOAuth: false };
        }
        if (lower.includes("pms")) {
            return { symbol: "↗", description: "Hotel PMS integration credentials", isOAuth: false };
        }
        if (lower.includes("outlook")) {
            return { symbol: "📧", description: "Outlook email credentials", isOAuth: false };
        }
        if (lower.includes("gmail")) {
            return { symbol: "✉️", description: "Email access credentials", isOAuth: false };
        }
        if (lower.includes("generic")) {
            return { symbol: "⚙️", description: "Store API keys or tokens", isOAuth: false };
        }
        const resolved = resolveOAuthProvider(term);
        if (resolved) {
            return {
                icon: OAUTH_ICONS[resolved.id] || null,
                symbol: "🪟",
                description: `Connect ${resolved.name} services`,
                isOAuth: true,
            };
        }
        return { symbol: "◇", description: "Custom credentials", isOAuth: false };
    };

    // Combine vault types strictly driven by database records from props.vaulttypelist
    const getAllVaultTypes = () => {
        if (props?.vaulttypelist && props.vaulttypelist.length > 0) {
            return props.vaulttypelist.map((vt) => {
                const meta = getTypeMetadata(vt.term);
                let customDesc = null;
                if (vt.details) {
                    try {
                        const parsed = typeof vt.details === "string" ? JSON.parse(vt.details) : vt.details;
                        if (parsed && typeof parsed === "object" && parsed.description) {
                            customDesc = parsed.description;
                        }
                    } catch (e) {}
                }
                return {
                    term: vt.term,
                    symbol: meta.symbol,
                    icon: meta.icon,
                    description: customDesc || meta.description || `${vt.term} credentials`,
                    isOAuth: meta.isOAuth,
                    details: vt.details,
                };
            });
        }
        return PROTOTYPE_TYPES;
    };

    const fnInputChange = (value, tag) => {
        if (value) {
            setInput((prev) => ({
                ...prev,
                [tag]: value,
                errors: {
                    ...prev.errors,
                    [tag]: "",
                },
            }));
        } else {
            setInput((prev) => ({
                ...prev,
                [tag]: "",
            }));
        }
    };

    const fnCustomInputChange = (value, keyname) => {
        const new_data1 = input?.detailsjson?.map((item) => {
            if (item?.keyname === keyname) {
                return {
                    ...item,
                    value: value,
                };
            } else {
                return item;
            }
        });
        setInput((prev) => ({
            ...prev,
            detailsjson: new_data1,
        }));
    };

    const handleTypeSelect = (selectedTerm) => {
        let temp = props?.vaulttypelist?.find((f) => f.term === selectedTerm);
        let CheckArray = commonservices.validateJsonString(temp?.details);
        if (CheckArray.valid) {
            let new_data = JSON.parse(temp?.details);
            if (new_data?.length > 0) {
                new_data = new_data.map((item) => ({
                    ...item,
                    value: "",
                }));
            }
            setInput((prev) => ({
                ...prev,
                type: temp?.term || selectedTerm,
                detailsjson: new_data,
                errors: {
                    ...prev.errors,
                    type: "",
                },
            }));
        } else {
            const defaultFields = getDefaultFieldsForType(selectedTerm);
            setInput((prev) => ({
                ...prev,
                type: temp ? temp.term : selectedTerm,
                detailsjson: defaultFields,
                errors: {
                    ...prev.errors,
                    type: "",
                },
            }));
        }

        // Initialize default scopes for OAuth
        if (isGoogle(selectedTerm)) {
            setSelectedScopes(["userinfo.email"]);
            setExpandedGroups({ "User Info": true });
        } else {
            const config = resolveOAuthProvider(selectedTerm);
            if (config) {
                setSelectedScopes(config.defaultScopes || []);
                const firstGroup = Object.keys(config.scopeGroups || {})[0];
                if (firstGroup) setExpandedGroups({ [firstGroup]: true });
            }
        }
    };

    const initializedTypeRef = React.useRef(false);

    // Load existing vault details in Update mode or select first type in Create mode
    useEffect(() => {
        if (props?.type === "Update" && props?.selecteddata?.passwordvaultid) {
            setUpdateLoader(true);
            const body = {
                id: props?.selecteddata?.passwordvaultid,
            };
            dispatch(PasswordVaultDetail(body))?.then((response) => {
                if (response?.payload?.isValidate) {
                    setUpdateLoader(false);
                    let responsjson = {};
                    try {
                        responsjson = JSON.parse(response?.payload?.data?.data?.detailsjson);
                    } catch (e) {
                        responsjson = {};
                    }
                    const keyValueArray = Object.entries(responsjson);
                    let temp2 = props?.vaulttypelist?.find(
                        (f) => f.term === props?.selecteddata?.type
                    );
                    let CheckArray = commonservices.validateJsonString(temp2?.details);
                    let parsedJson = CheckArray.valid ? JSON.parse(temp2?.details) : [];

                    if (CheckArray.valid && parsedJson.length > 0) {
                        const json_with_value = parsedJson.map((item) => {
                            const valuePair = keyValueArray.find(([key]) => key === item.keyname);
                            return {
                                ...item,
                                value: valuePair ? valuePair[1] : "",
                            };
                        });
                        setInput({
                            passwordvaultid: response?.payload?.data?.data?.passwordvaultid,
                            displayname: response?.payload?.data?.data?.displayname,
                            type: response?.payload?.data?.data?.type,
                            detailsjson: json_with_value,
                            savedAuthData: responsjson,
                            errors: { type: "", displayname: "" },
                        });
                    } else {
                        const defaultFields = getDefaultFieldsForType(response?.payload?.data?.data?.type);
                        const fieldsWithValues = defaultFields.map((item) => {
                            const valuePair = keyValueArray.find(([key]) => key === item.keyname);
                            return {
                                ...item,
                                value: valuePair ? valuePair[1] : "",
                            };
                        });
                        setInput({
                            passwordvaultid: response?.payload?.data?.data?.passwordvaultid,
                            displayname: response?.payload?.data?.data?.displayname,
                            type: response?.payload?.data?.data?.type,
                            detailsjson: fieldsWithValues,
                            savedAuthData: responsjson,
                            errors: { type: "", displayname: "" },
                        });
                    }

                    if (responsjson?.selected_scopes && responsjson.selected_scopes.length > 0) {
                        setSelectedScopes(responsjson.selected_scopes);
                    } else if (responsjson?.scopes && responsjson.scopes.length > 0) {
                        setSelectedScopes(responsjson.scopes);
                    }
                    if (responsjson?.shop) {
                        setShopDomain(responsjson.shop);
                    }
                } else {
                    setUpdateLoader(false);
                }
            });
        } else if (props?.type !== "Update") {
            // In Create mode, select the first type in the list by default
            if (!initializedTypeRef.current) {
                const firstTerm = props?.vaulttypelist?.[0]?.term || PROTOTYPE_TYPES[0]?.term || "Gmail";
                if (props?.vaulttypelist && props.vaulttypelist.length > 0) {
                    initializedTypeRef.current = true;
                }
                handleTypeSelect(firstTerm);
            }
        }
    }, [props?.type, props?.selecteddata?.passwordvaultid, props?.vaulttypelist]);

    // Permissions toggling logic
    const toggleGroup = (groupName) => {
        setExpandedGroups((prev) => ({
            ...prev,
            [groupName]: !prev[groupName],
        }));
    };

    const toggleScope = (scopeId, isRequired) => {
        if (isRequired) return;
        setSelectedScopes((prev) =>
            prev.includes(scopeId) ? prev.filter((id) => id !== scopeId) : [...prev, scopeId]
        );
    };

    const selectAllInGroup = (scopes, isGoogleScope) => {
        const scopeIds = scopes.map((s) => s.id);
        const allSelected = scopeIds.every((id) => selectedScopes.includes(id));

        if (allSelected) {
            setSelectedScopes((prev) =>
                prev.filter((id) => !scopeIds.includes(id) || (isGoogleScope && id === "userinfo.email"))
            );
        } else {
            setSelectedScopes((prev) => [...new Set([...prev, ...scopeIds])]);
        }
    };

    const toggleAllScopes = (groupsObj, isGoogleScope) => {
        const allScopes = Object.values(groupsObj).flat();
        const allIds = allScopes.map((s) => s.id);
        const allSelected = allIds.every((id) => selectedScopes.includes(id));

        if (allSelected) {
            setSelectedScopes(isGoogleScope ? ["userinfo.email"] : []);
        } else {
            setSelectedScopes(allIds);
        }
    };

    const getSelectedGoogleScopeUrls = () => {
        const allScopes = Object.values(GOOGLE_SCOPE_GROUPS).flat();
        return allScopes.filter((s) => selectedScopes.includes(s.id)).map((s) => s.scope);
    };

    const getSelectedOAuthScopeUrls = (config) => {
        const allScopes = Object.values(config?.scopeGroups || {}).flat();
        return allScopes.filter((s) => selectedScopes.includes(s.id)).map((s) => s.scope);
    };

    // Google OAuth redirect
    const handleGoogleAuthorize = () => {
        if (!input?.displayname || input?.displayname?.trim() === "") {
            toast.error("Please enter a display name first");
            setCurrentStep(2);
            return;
        }

        const scopeUrls = getSelectedGoogleScopeUrls();
        if (scopeUrls.length === 0) {
            toast.error("Please select at least one permission");
            setCurrentStep(3);
            return;
        }

        setAuthLoading(true);

        const inputWithScopes = {
            ...input,
            selectedScopes: selectedScopes,
        };

        const params = new URLSearchParams({
            client_id: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID,
            redirect_uri: window.location.href,
            response_type: "code",
            scope: scopeUrls.join(" "),
            access_type: "offline",
            prompt: "consent",
        });

        localStorage.setItem("inputValue", JSON.stringify(inputWithScopes));
        window.location.href = `https://accounts.google.com/o/oauth2/auth?${params.toString()}`;
    };

    // Other OAuth providers redirect
    const handleOAuthAuthorize = (config) => {
        if (!input?.displayname || input?.displayname?.trim() === "") {
            toast.error("Please enter a display name first");
            setCurrentStep(2);
            return;
        }

        let cleanedShop = "";
        if (config.requiresShopDomain) {
            if (!shopDomain || shopDomain.trim() === "") {
                setShopDomainError("Please enter your Shopify store domain");
                toast.error("Please enter your Shopify store domain");
                setCurrentStep(2);
                return;
            }
            cleanedShop = shopDomain.trim().toLowerCase().replace(/^https?:\/\//, "").replace(/\/.*$/, "");
            if (!cleanedShop.includes(".")) {
                cleanedShop = `${cleanedShop}.myshopify.com`;
            }
        }

        const scopeUrls = getSelectedOAuthScopeUrls(config);
        if (scopeUrls.length === 0) {
            toast.error("Please select at least one permission");
            setCurrentStep(3);
            return;
        }

        setAuthLoading(true);

        const inputWithScopes = {
            ...input,
            auth_provider: config.id,
            type: input?.type || config.name,
            selectedScopes: selectedScopes,
            shop: cleanedShop,
            shopDomain: cleanedShop,
        };

        localStorage.setItem("inputValue", JSON.stringify(inputWithScopes));

        const redirectUri = window.location.origin + "/management-listing";
        const scopeDelimiter = config.scopeDelimiter || " ";

        dispatch(
            OAuthVaultGetRedirectUrl({
                provider: config.id,
                scopes: scopeUrls.join(scopeDelimiter),
                redirectUri: redirectUri,
                shop: cleanedShop,
            })
        )
            ?.then((res) => {
                setAuthLoading(false);
                if (res?.payload?.data?.status_code === 1 && res?.payload?.data?.data) {
                    window.location.href = res.payload.data.data;
                } else {
                    toast.error(res?.payload?.data?.message || `Failed to generate ${config.name} authorization URL`);
                }
            })
            .catch(() => {
                setAuthLoading(false);
                toast.error(`Failed to connect to ${config.name} service`);
            });
    };

    // Form navigation handlers
    const handleNext = () => {
        if (currentStep === 1) {
            if (!input?.type) {
                toast.error("Please select a vault type");
                return;
            }
            setCurrentStep(2);
            return;
        }

        if (currentStep === 2) {
            if (!input?.displayname || input?.displayname?.trim() === "") {
                setInput((prev) => ({
                    ...prev,
                    errors: {
                        ...prev.errors,
                        displayname: "This Field is a required field",
                    },
                }));
                toast.error("Please enter a display name");
                return;
            }

            if (oauthConfig?.requiresShopDomain) {
                if (!shopDomain || shopDomain.trim() === "") {
                    setShopDomainError("Please enter your Shopify store domain");
                    toast.error("Please enter your Shopify store domain");
                    return;
                }
            }

            // If OAuth, proceed to Step 3 (Permissions). If non-OAuth, proceed to Step 3 (Review).
            setCurrentStep(3);
            return;
        }

        if (currentStep === 3) {
            if (isOAuthType(input?.type)) {
                if (selectedScopes.length === 0) {
                    toast.error("Please select at least one permission");
                    return;
                }
                setCurrentStep(4); // Move to Step 4 (Review)
            } else {
                // Non-OAuth Step 3 is Review -> calls handleSubmit
                handleSubmit();
            }
            return;
        }

        if (currentStep === 4) {
            if (isOAuthType(input?.type)) {
                // OAuth Step 4 is Review -> Move to Step 5 (Authorize)
                setCurrentStep(5);
            }
            return;
        }

        if (currentStep === 5) {
            // OAuth Step 5 is Authorize
            if (isConnected) {
                handleSubmit();
            } else {
                if (isGoogle(input?.type)) {
                    handleGoogleAuthorize();
                } else if (oauthConfig) {
                    handleOAuthAuthorize(oauthConfig);
                }
            }
        }
    };

    const handleBack = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleStepClick = (stepIndex) => {
        // Can only jump back to previously completed steps
        if (stepIndex < currentStep) {
            setCurrentStep(stepIndex);
        }
    };

    // Final submission to PasswordVaultSave API
    const handleSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();

        let obj = commonservices.fnCheckValidationOfObject(input);
        setInput({
            ...obj.obj,
        });

        if (!input?.displayname || input?.displayname?.trim() === "") {
            toast.error("Please enter a display name");
            setCurrentStep(2);
            return;
        }

        if (obj.isValid) {
            setLoading(true);
            let newVal = [];
            if (input?.detailsjson?.length > 0) {
                input?.detailsjson?.forEach((element) => {
                    newVal.push({
                        [element?.keyname]: element?.value,
                    });
                });
            }
            let filterVal = Object.assign({}, ...newVal);

            if (isOAuthType(input?.type)) {
                if (input?.savedAuthData) {
                    filterVal = { ...input.savedAuthData, ...filterVal };
                }
                filterVal["selected_scopes"] = selectedScopes;
                if (shopDomain) filterVal["shop"] = shopDomain;
            }

            let body = {
                passwordvaultid: props?.selecteddata?.passwordvaultid
                    ? props?.selecteddata?.passwordvaultid
                    : input?.passwordvaultid,
                type: input?.type,
                detailsjson: JSON.stringify(filterVal),
                displayname: input?.displayname,
                username: filterVal?.username || input?.username || "",
                password: filterVal?.password || input?.password || "",
            };

            dispatch(PasswordVaultSave(body))?.then((response) => {
                if (response?.payload?.isValidate) {
                    props.onHide();
                    props.bindlist();
                    setLoading(false);
                }
                if (!response?.payload?.isValidate) {
                    setLoading(false);
                }
            });
        }
    };

    const isConnected = !!(input?.savedAuthData?.token || input?.savedAuthData?.access_token);
    const activeVaultTypes = getAllVaultTypes();
    const currentScopeGroups = isGoogle(input?.type)
        ? GOOGLE_SCOPE_GROUPS
        : oauthConfig?.scopeGroups || {};

    // Calculate total scopes and selected in group
    const allScopesInCurrentConfig = Object.values(currentScopeGroups).flat();
    const allScopesSelected =
        allScopesInCurrentConfig.length > 0 &&
        allScopesInCurrentConfig.every((s) => selectedScopes.includes(s.id));

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="passwordvaultmodal passwordvault-wizard-modal"
            backdrop="static"
        >
            {(Loading || authLoading) && <MainpageLoader />}

            {/* Modal Header matching system popups */}
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props?.type === "Update" ? "Update Password Vault" : "Create Password Vault"}
                </Modal.Title>
            </Modal.Header>

            {/* Stepper / Progress Indicator */}
            <div className="wizard-steps">
                {stepLabels.map((label, index) => {
                    const stepNumber = index + 1;
                    const isDone = stepNumber < currentStep;
                    const isActive = stepNumber === currentStep;

                    return (
                        <div
                            key={label}
                            className={`wizard-step ${isDone ? "done" : ""} ${isActive ? "active" : ""}`}
                            onClick={() => handleStepClick(stepNumber)}
                        >
                            <div className="wizard-bubble">
                                {isDone ? "✓" : stepNumber}
                            </div>
                            {label}
                        </div>
                    );
                })}
            </div>

            {/* Modal Body */}
            <Modal.Body>
                {UpdateLoader ? (
                    <Loader type={LoaderType.Line} count={4} />
                ) : (
                    <>
                        {/* STEP 1: SELECT TYPE */}
                        {currentStep === 1 && (
                            <div>
                                <h3 className="wizard-step-title">Select vault type</h3>
                                <p className="wizard-step-subtitle">
                                    Choose the type of credential or access token you want to store.
                                </p>
                                <div className="wizard-grid">
                                    {activeVaultTypes.map((vt) => {
                                        const isSelected = input?.type === vt.term;
                                        return (
                                            <button
                                                key={vt.term}
                                                type="button"
                                                className={`wizard-type-card ${isSelected ? "sel" : ""}`}
                                                onClick={() => handleTypeSelect(vt.term)}
                                            >
                                                {isSelected && <span className="card-check">✓</span>}
                                                <span className="card-symbol">
                                                    <VaultTypeIcon
                                                        type={vt.term}
                                                        details={vt.details}
                                                        size={22}
                                                        showBorder={false}
                                                    />
                                                </span>
                                                <strong>{vt.term}</strong>
                                                <small>{vt.description}</small>
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {/* STEP 2: CONFIGURE */}
                        {currentStep === 2 && (
                            <div>
                                <h3 className="wizard-step-title">
                                    {isOAuthType(input?.type) ? "Basic Details" : `${input?.type} Configuration`}
                                </h3>
                                <p className="wizard-step-subtitle">
                                    {isOAuthType(input?.type)
                                        ? "Provide a display name for this vault. You will authorize access in a later step."
                                        : "Enter the connection details required for this vault type."}
                                </p>

                                <div className="wizard-formgrid">
                                    {/* Display Name Field (Always Full Width) */}
                                    <div className="full mb-3">
                                        <Form.Group className="form-group mb-0">
                                            <Form.Label className="common-label">
                                                Display Name <span className="ms-1 red-color-text">*</span>
                                            </Form.Label>
                                            <div className="position-relative">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter your display name here"
                                                    className="common-input"
                                                    maxLength={167}
                                                    value={input?.displayname}
                                                    onChange={(e) => fnInputChange(e.target.value, "displayname")}
                                                    isInvalid={!!input?.errors?.displayname}
                                                />
                                                {input?.errors?.displayname && (
                                                    <Form.Control.Feedback type="invalid">
                                                        <span className="error-message-icon">
                                                            <img
                                                                src={infoIcon}
                                                                alt="infoIcon"
                                                                title={input.errors.displayname}
                                                            />
                                                        </span>
                                                    </Form.Control.Feedback>
                                                )}
                                            </div>
                                        </Form.Group>
                                    </div>

                                    {/* Shopify Store Domain if applicable */}
                                    {oauthConfig?.requiresShopDomain && (
                                        <div className="full mb-3">
                                            <Form.Group className="form-group mb-0">
                                                <Form.Label className="common-label">
                                                    Shopify Store Domain <span className="ms-1 red-color-text">*</span>
                                                </Form.Label>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={oauthConfig.shopDomainPlaceholder || "your-store.myshopify.com"}
                                                        className="common-input"
                                                        value={shopDomain}
                                                        onChange={(e) => {
                                                            setShopDomain(e.target.value);
                                                            if (shopDomainError) setShopDomainError("");
                                                        }}
                                                        isInvalid={!!shopDomainError}
                                                    />
                                                    {shopDomainError && (
                                                        <Form.Control.Feedback type="invalid">
                                                            <span className="error-message-icon">
                                                                <img
                                                                    src={infoIcon}
                                                                    alt="infoIcon"
                                                                    title={shopDomainError}
                                                                />
                                                            </span>
                                                        </Form.Control.Feedback>
                                                    )}
                                                </div>
                                            </Form.Group>
                                        </div>
                                    )}

                                    {/* Dynamic Fields for Non-OAuth Types */}
                                    {input?.detailsjson?.length > 0 &&
                                        input?.detailsjson?.map((item, index) => {
                                            const isFullWidth = item?.keytype === "Text Area" || item?.keyname === "description" || item?.keyname === "apiKey" || item?.keyname === "database";

                                            return (
                                                <div
                                                    key={`${item?.keyname}_${index}`}
                                                    className={`${isFullWidth ? "full" : ""} mb-3`}
                                                >
                                                    <Form.Group className="form-group mb-0">
                                                        <Form.Label className="common-label">
                                                            {item?.display}
                                                        </Form.Label>

                                                        {item?.keytype === "Password" && (
                                                            <div className="input-type-pass">
                                                                <Form.Control
                                                                    type={passwordVisible ? "text" : "password"}
                                                                    placeholder={item?.display}
                                                                    className="common-input"
                                                                    maxLength={100}
                                                                    value={item?.value}
                                                                    onChange={(e) => fnCustomInputChange(e.target.value, item?.keyname)}
                                                                    isInvalid={!!item?.error}
                                                                />
                                                                <img
                                                                    src={passwordVisible ? openeye : closeeye}
                                                                    alt="toggle password"
                                                                    onClick={() => setPasswordVisible(!passwordVisible)}
                                                                />
                                                                {item?.error && (
                                                                    <Form.Control.Feedback type="invalid">
                                                                        <span className="error-message-icon password-error-message-icon">
                                                                            <img
                                                                                src={infoIcon}
                                                                                alt="infoIcon"
                                                                                title={item?.error}
                                                                            />
                                                                        </span>
                                                                    </Form.Control.Feedback>
                                                                )}
                                                            </div>
                                                        )}

                                                        {item?.keytype === "Text Box" && (
                                                            <div className="position-relative">
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder={item?.display}
                                                                    className="common-input"
                                                                    maxLength={160}
                                                                    value={item?.value}
                                                                    onChange={(e) => fnCustomInputChange(e.target.value, item?.keyname)}
                                                                    isInvalid={!!item?.error}
                                                                />
                                                                {item?.error && (
                                                                    <Form.Control.Feedback type="invalid">
                                                                        <span className="error-message-icon">
                                                                            <img
                                                                                src={infoIcon}
                                                                                alt="infoIcon"
                                                                                title={item?.error}
                                                                            />
                                                                        </span>
                                                                    </Form.Control.Feedback>
                                                                )}
                                                            </div>
                                                        )}

                                                        {item?.keytype === "Number" && (
                                                            <div className="position-relative">
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder={item?.display}
                                                                    className="common-input"
                                                                    maxLength={10}
                                                                    value={item?.value}
                                                                    onKeyPress={(event) => {
                                                                        if (!/[0-9]/.test(event.key)) {
                                                                            event.preventDefault();
                                                                        }
                                                                    }}
                                                                    onChange={(e) => fnCustomInputChange(e.target.value, item?.keyname)}
                                                                    isInvalid={!!item?.error}
                                                                />
                                                                {item?.error && (
                                                                    <Form.Control.Feedback type="invalid">
                                                                        <span className="error-message-icon">
                                                                            <img
                                                                                src={infoIcon}
                                                                                alt="infoIcon"
                                                                                title={item?.error}
                                                                            />
                                                                        </span>
                                                                    </Form.Control.Feedback>
                                                                )}
                                                            </div>
                                                        )}

                                                        {item?.keytype === "Text Area" && (
                                                            <div className="position-relative">
                                                                <Form.Control
                                                                    as="textarea"
                                                                    rows={3}
                                                                    placeholder={item?.display}
                                                                    className="common-input"
                                                                    maxLength={250}
                                                                    value={item?.value}
                                                                    onChange={(e) => fnCustomInputChange(e.target.value, item?.keyname)}
                                                                    isInvalid={!!item?.error}
                                                                />
                                                                {item?.error && (
                                                                    <Form.Control.Feedback type="invalid">
                                                                        <span className="error-message-icon">
                                                                            <img
                                                                                src={infoIcon}
                                                                                alt="infoIcon"
                                                                                title={item?.error}
                                                                            />
                                                                        </span>
                                                                    </Form.Control.Feedback>
                                                                )}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </div>
                                            );
                                        })}
                                </div>

                                {isOAuthType(input?.type) && (
                                    <div className="wizard-info-callout">
                                        <span className="info-icon">ⓘ</span>
                                        <span>
                                            You will select the required permissions and authorize access in the next steps. Only grant the scopes your workflow needs.
                                        </span>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* STEP 3: PERMISSIONS (Only for OAuth/Google types) */}
                        {currentStep === 3 && isOAuthType(input?.type) && (
                            <div>
                                <div className="permissions-header-row">
                                    <div>
                                        <h3 className="wizard-step-title mb-1">
                                            {isGoogle(input?.type) ? "Choose Google permissions" : `Choose ${oauthConfig?.name || "Provider"} permissions`}
                                        </h3>
                                        <p className="wizard-step-subtitle mb-0">
                                            Select only the services this vault needs to access.
                                        </p>
                                    </div>
                                    <label className="select-all-toggle">
                                        <input
                                            type="checkbox"
                                            checked={allScopesSelected}
                                            onChange={() => toggleAllScopes(currentScopeGroups, isGoogle(input?.type))}
                                        />
                                        Select all
                                    </label>
                                </div>

                                <div className="wizard-perm-list">
                                    {Object.entries(currentScopeGroups).map(([groupName, scopes]) => {
                                        const isExpanded = !!expandedGroups[groupName];
                                        const selectedInGroup = scopes.filter((s) => selectedScopes.includes(s.id)).length;
                                        const allInGroupSelected = selectedInGroup === scopes.length;

                                        return (
                                            <div
                                                key={groupName}
                                                className={`wizard-perm-card ${isExpanded ? "open" : ""}`}
                                            >
                                                <div
                                                    className="wizard-permrow"
                                                    onClick={() => toggleGroup(groupName)}
                                                >
                                                    <span className={`wizard-expand-btn ${isExpanded ? "open" : ""}`}>
                                                        ▶
                                                    </span>
                                                    <div className="wizard-perm-info">
                                                        <strong>
                                                            {groupName}
                                                            <span className="group-badge">
                                                                ({selectedInGroup}/{scopes.length})
                                                            </span>
                                                        </strong>
                                                        <small>{scopes[0]?.description || `Permissions for ${groupName}`}</small>
                                                    </div>
                                                    <input
                                                        type="checkbox"
                                                        checked={allInGroupSelected}
                                                        onChange={(e) => {
                                                            e.stopPropagation();
                                                            selectAllInGroup(scopes, isGoogle(input?.type));
                                                        }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                </div>

                                                {isExpanded && (
                                                    <div className="wizard-perm-details">
                                                        {scopes.map((scope) => {
                                                            const isRequired = isGoogle(input?.type)
                                                                ? scope.id === "userinfo.email"
                                                                : oauthConfig?.requiredScopes?.includes(scope.id);

                                                            return (
                                                                <div key={scope.id} className="wizard-scope-row">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`scope_${scope.id}`}
                                                                        checked={selectedScopes.includes(scope.id)}
                                                                        disabled={isRequired}
                                                                        onChange={() => toggleScope(scope.id, isRequired)}
                                                                    />
                                                                    <div className="scope-text">
                                                                        <label htmlFor={`scope_${scope.id}`} className="scope-title mb-0 cursor-pointer">
                                                                            {scope.label}
                                                                            {isRequired && (
                                                                                <span className="required-badge">Required</span>
                                                                            )}
                                                                        </label>
                                                                        <span className="scope-desc">{scope.description}</span>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="wizard-count-banner">
                                    {selectedScopes.length} permission(s) selected
                                </div>
                            </div>
                        )}

                        {/* STEP 4 (or STEP 3 for non-OAuth): REVIEW */}
                        {((currentStep === 4 && isOAuthType(input?.type)) ||
                            (currentStep === 3 && !isOAuthType(input?.type))) && (
                            <div>
                                <h3 className="wizard-step-title">
                                    {isOAuthType(input?.type) ? "Review Details" : "Review & Create"}
                                </h3>
                                <p className="wizard-step-subtitle">
                                    {isOAuthType(input?.type)
                                        ? "Confirm the vault information before proceeding to authorization."
                                        : "Confirm the vault information before saving it."}
                                </p>

                                <div className="wizard-review-card">
                                    <div className="wizard-review-row">
                                        <span className="label">Vault Type</span>
                                        <strong className="value">
                                            <span className="review-type-badge">
                                                {input?.type}
                                            </span>
                                        </strong>
                                    </div>

                                    <div className="wizard-review-row">
                                        <span className="label">Display Name</span>
                                        <strong className="value">{input?.displayname || "Not entered"}</strong>
                                    </div>

                                    {/* Non-OAuth Details */}
                                    {!isOAuthType(input?.type) &&
                                        input?.detailsjson?.map((item, idx) => {
                                            if (!item?.value) return null;
                                            const isPassword = item?.keytype === "Password" || item?.keyname === "password" || item?.keyname === "apiKey";
                                            return (
                                                <div key={idx} className="wizard-review-row">
                                                    <span className="label">{item?.display}</span>
                                                    <strong className="value">
                                                        {isPassword ? "••••••••••••" : item?.value}
                                                    </strong>
                                                </div>
                                            );
                                        })}

                                    {/* OAuth Permissions & Auth Status */}
                                    {isOAuthType(input?.type) && (
                                        <>
                                            {shopDomain && (
                                                <div className="wizard-review-row">
                                                    <span className="label">Shopify Domain</span>
                                                    <strong className="value">{shopDomain}</strong>
                                                </div>
                                            )}
                                            <div className="wizard-review-row">
                                                <span className="label">Permissions</span>
                                                <strong className="value">
                                                    {selectedScopes.length} permission(s) selected
                                                </strong>
                                            </div>
                                            <div className="wizard-review-row">
                                                <span className="label">Authorization</span>
                                                <strong className="value">
                                                    {isConnected ? (
                                                        <span className="review-status-active">Authorized (Active)</span>
                                                    ) : (
                                                        <span className="review-status-pending">Authorization Required in Next Step</span>
                                                    )}
                                                </strong>
                                            </div>
                                        </>
                                    )}

                                    {/* Description if present */}
                                    {input?.detailsjson?.find((i) => i.keyname === "description")?.value && (
                                        <div className="wizard-review-row">
                                            <span className="label">Description</span>
                                            <strong className="value">
                                                {input?.detailsjson?.find((i) => i.keyname === "description")?.value}
                                            </strong>
                                        </div>
                                    )}
                                </div>

                                <div className="wizard-info-callout">
                                    <span className="info-icon">ℹ</span>
                                    <span>
                                        Credentials and access tokens are secured with AES-256 encryption within your tenant workspace.
                                    </span>
                                </div>
                            </div>
                        )}

                        {/* STEP 5: AUTHORIZE (Only for OAuth/Google types) */}
                        {currentStep === 5 && isOAuthType(input?.type) && (
                            <div className="wizard-auth-card">
                                <div className="wizard-auth-icon">
                                    <VaultTypeIcon
                                        type={input?.type}
                                        details={props?.vaulttypelist?.find((f) => f.term === input?.type)?.details}
                                        size={48}
                                        showBorder={false}
                                    />
                                </div>

                                <h3>
                                    {isGoogle(input?.type) ? "Authorize with Google" : `Authorize with ${oauthConfig?.name || "Provider"}`}
                                </h3>

                                <p>
                                    Authorize the selected permissions to generate an access token for this vault. You will be redirected to sign in and approve access.
                                </p>

                                {isConnected && (
                                    <div className="auth-status-connected">
                                        <span>✓</span>
                                        <span>
                                            Active connection established {shopDomain ? `with ${shopDomain}` : ""}
                                        </span>
                                    </div>
                                )}

                                <div>
                                    <button
                                        type="button"
                                        disabled={authLoading}
                                        className="white-sign-in-btn auth-action-btn"
                                        onClick={() => {
                                            if (isGoogle(input?.type)) {
                                                handleGoogleAuthorize();
                                            } else if (oauthConfig) {
                                                handleOAuthAuthorize(oauthConfig);
                                            }
                                        }}
                                    >
                                        {authLoading ? (
                                            <>
                                                <span>Connecting...</span>
                                                <Spinner animation="border" size="sm" className="ms-2" />
                                            </>
                                        ) : (
                                            <>
                                                {isGoogle(input?.type) ? (
                                                    <>
                                                        <VaultTypeIcon type="Google Authenticator" size={18} showBorder={false} />
                                                        <span>Generate Token with Selected Scopes</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <VaultTypeIcon type={input?.type} size={18} showBorder={false} />
                                                        <span>{oauthConfig?.buttonText || `Sign in with ${oauthConfig?.name || input?.type}`}</span>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </button>
                                </div>

                                <div className="auth-security-tip">
                                    <span>🔒</span>
                                    <span>
                                        Authorized access tokens are encrypted and stored securely in your QuantumDataLytica Password Vault.
                                    </span>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </Modal.Body>

            {/* Modal Footer matching system popups */}
            <Modal.Footer>
                {currentStep === 1 && (
                    <button
                        className="grey-btn w-auto"
                        type="button"
                        onClick={props.onHide}
                    >
                        Cancel
                    </button>
                )}

                {currentStep > 1 && (
                    <button
                        className="grey-btn w-auto"
                        type="button"
                        onClick={handleBack}
                    >
                        ← Back
                    </button>
                )}

                {/* Step button logic */}
                {((currentStep < 4 && isOAuthType(input?.type)) ||
                    (currentStep < 3 && !isOAuthType(input?.type))) && (
                    <button
                        className="blue-btn w-auto"
                        type="button"
                        onClick={handleNext}
                    >
                        {isOAuthType(input?.type) && currentStep === 3
                            ? "Continue to Review →"
                            : "Next →"}
                    </button>
                )}

                {/* OAuth Step 4 (Review) Continue to Authorize button */}
                {isOAuthType(input?.type) && currentStep === 4 && (
                    <button
                        className="blue-btn w-auto"
                        type="button"
                        onClick={handleNext}
                    >
                        Continue to Authorize →
                    </button>
                )}

                {/* Final Step: Non-OAuth Step 3 (Review) */}
                {!isOAuthType(input?.type) && currentStep === 3 && (
                    <button
                        disabled={Loading}
                        className="blue-btn w-auto"
                        type="button"
                        onClick={handleSubmit}
                    >
                        {Loading ? (
                            <SubmitLoading />
                        ) : props?.type === "Update" ? (
                            "Update Vault"
                        ) : (
                            "Create Vault"
                        )}
                    </button>
                )}

                {/* Final Step: OAuth Step 5 (Authorize) */}
                {isOAuthType(input?.type) && currentStep === 5 && (
                    <>
                        {isConnected ? (
                            <button
                                disabled={Loading}
                                className="blue-btn w-auto"
                                type="button"
                                onClick={handleSubmit}
                            >
                                {Loading ? (
                                    <SubmitLoading />
                                ) : props?.type === "Update" ? (
                                    "Update Vault"
                                ) : (
                                    "Create Vault"
                                )}
                            </button>
                        ) : (
                            <button
                                disabled={authLoading}
                                className="blue-btn w-auto"
                                type="button"
                                onClick={() => {
                                    if (isGoogle(input?.type)) {
                                        handleGoogleAuthorize();
                                    } else if (oauthConfig) {
                                        handleOAuthAuthorize(oauthConfig);
                                    }
                                }}
                            >
                                {authLoading ? (
                                    <>
                                        <Spinner animation="border" size="sm" className="me-2" />
                                        <span>Connecting...</span>
                                    </>
                                ) : isGoogle(input?.type) ? (
                                    "Authorize with Google →"
                                ) : (
                                    `Authorize with ${oauthConfig?.name || "Provider"} →`
                                )}
                            </button>
                        )}
                    </>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default PasswordVaultModal;
